module.exports = __webpack_public_path__ + "img/exclamation-diamond-fill.d22dcb51.svg";